import axios from 'axios'
import {BaseConfigModel, FooterConfig, HeaderAdModel, HeaderConfigModel, SocialsModel} from "./_model";
import {MenuModel} from "../../Menu/Menu_list/core/_models";
import {PageContent} from "../../Page/Post-List/core/_model";

const API_URL = process.env.REACT_APP_API_URL
const USER_URL = `${API_URL}/api/v1/BaseConfig`

const GetHeaderConfig = ()=>{
    return axios.get<HeaderConfigModel>(`${USER_URL}/GetHeaderConfig`)
}
const PostHeaderConfig = (model : HeaderConfigModel) =>{
    return axios.post(`${USER_URL}/PostHeaderConfig`,model);
}
const GetHeaderAddConfig = ()=>{
    return axios.get<HeaderAdModel>(`${USER_URL}/GetHeaderAddConfig`)
}
const PostHeaderAddConfig = (model : HeaderAdModel) =>{
    return axios.post(`${USER_URL}/PostHeaderAddConfig`,model);
}

const GetMenus = (search?: string)=>{
    return axios.get<MenuModel[]>(`${USER_URL}/GetMenus${search && `?search=${search}`}`)
}
const GetAds = (search?: string)=>{
    return axios.get<MenuModel[]>(`${USER_URL}/GetAds${search && `?search=${search}`}`)
}
const GetFooterConfig = ()=>{
    return axios.get<FooterConfig>(`${USER_URL}/GetFooterConfig`)
}
const PostFooterConfig = (model : FooterConfig) =>{
    return axios.post(`${USER_URL}/PostFooterConfig`,model);
}
const GetSiteInfoConfig = ()=>{
    return axios.get<BaseConfigModel>(`${USER_URL}/GetSiteInfoConfig`)
}
const PostSiteInfoConfig = (model : BaseConfigModel) =>{
    return axios.post(`${USER_URL}/PostSiteInfoConfig`,model);
}
const GetSocialConfig = ()=>{
    return axios.get<SocialsModel>(`${USER_URL}/GetSocialConfig`)
}
const PostSocialConfig = (model : SocialsModel) =>{
    return axios.post(`${USER_URL}/PostSocialConfig`,model);
}
const GetFirstID = ()=>{
    return axios.get<{id:number , title : string}>(`${USER_URL}/GetFirstPageId`)
}
const setFirstID = (id:{id:number , title : string})=>{
    return  axios.post(`${USER_URL}/SetFirstPageID`,id)
}
const GetPages = (search?: string)=>{
    return axios.get<MenuModel[]>(`${USER_URL}/GetPages${search && `?search=${search}`}`)
}
const GetPostSildeConfig = ()=>{
    return axios.get<PageContent[]>(`${USER_URL}/GetPostSildeConfig`)
}
const SetPostSildeConfig = (model :any) =>{
    return axios.post(`${USER_URL}/SetPostSildeConfig`,model)
}
const ClearCash = () =>{
    return axios.get(`${USER_URL}/ClearCash`)
}
export  {
    ClearCash,
    GetPostSildeConfig,
    SetPostSildeConfig,
    GetPages,
    GetFirstID,
    setFirstID,
    GetSiteInfoConfig,
    PostSiteInfoConfig,
    GetSocialConfig,
    PostSocialConfig,
    GetFooterConfig,
    PostFooterConfig,
    GetHeaderConfig ,
    PostHeaderConfig,
    GetMenus,
    GetHeaderAddConfig,
    PostHeaderAddConfig,
    GetAds
}
